import useSWR from 'swr';

import { SERVICES } from '@shared/constants/apiConfig';
import { IStipType } from '@shared/interfaces';

export const useStipTypes = () => {
  const { data } = useSWR<IStipType[]>(`${SERVICES.DOCUMENT}/stipTypes`, {revalidateOnMount: undefined});
  return { stipTypes: data };
};
